const expand = (hex) => {
    const h = hex.startsWith("#") ? hex.slice(1) : hex;
    if (h.length === 3) {
        return h
            .split("")
            .map((c) => c + c)
            .join("");
    }
    return h;
};
const parseRgb = (hex) => {
    const h = expand(hex);
    if (h.length !== 6)
        return null;
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    if ([r, g, b].some((v) => Number.isNaN(v)))
        return null;
    return { r, g, b };
};
// YIQ-based perceived brightness (0-255). Threshold ~140 picks dark text
// slightly more aggressively than the canonical 128 — it tends to read better
// on borderline mids like sky-blue or olive.
const YIQ_THRESHOLD = 140;
export const isLightColor = (hex) => {
    const rgb = parseRgb(hex);
    if (!rgb)
        return false;
    const yiq = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    return yiq >= YIQ_THRESHOLD;
};
export const contrastText = (bgHex) => isLightColor(bgHex) ? "#0a0a0a" : "#ffffff";
